import React from 'react';

import { useSelector } from 'react-redux';
import { RootState } from '@share/utils';
import { useParams } from 'react-router-dom';
import { ILuxuryHomeLocation } from '@share/common-types';

import './style.scss';

const defaultImage = 'https://travcoding-hotel-resources.s3.us-east-1.amazonaws.com/front/luxury/luxury-hero.jpg';

export const LuxuryHomesHero: React.FC = () => {

  const { locations } = useSelector((state: RootState) => state.luxuryHomesStore);

  const { placeId } = useParams<{ placeId: string }>();

  const place = locations?.find((l: ILuxuryHomeLocation) => l.id?.toString() === placeId?.toString());

  return (
    <section className="luxury-homes-place-hero" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${place?.image || defaultImage})` }}>
      <div className="luxury-homes-place-hero__content">
        <h1>{place?.name}</h1>
        <h2>{place?.country}</h2>

        <div className="luxury-homes-place-hero__content-separator">
          <div className="luxury-homes-place-hero__content-separator-line"></div>
          <div className="luxury-homes-place-hero__content-separator-dot"></div>
          <div className="luxury-homes-place-hero__content-separator-line"></div>
        </div>

        <p>{place?.description}</p>
      </div>
    </section>
  );
};
